import { render, staticRenderFns } from "./bdate.vue?vue&type=template&id=1076b7dc&"
import script from "./bdate.vue?vue&type=script&lang=ts&"
export * from "./bdate.vue?vue&type=script&lang=ts&"
import style0 from "./bdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports